import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useDispatch, useSelector } from 'react-redux'

import { CreateTestConnectionModal } from './create_test_connection_modal'
import { isSamlTestModalOpenSelector } from './selectors'
import {
  openTestSamlConnectionModal,
  resetTestSamlSettings
} from './slice'


export const TestSamlConnectionButton = () => {
  const dispatch = useDispatch()
  const isModalOpen = useSelector(isSamlTestModalOpenSelector)

  const openModal = () => dispatch(openTestSamlConnectionModal())
  const handleOnClose = () => dispatch(resetTestSamlSettings())

  return (
    <>
      <CreateTestConnectionModal
        isOpen={isModalOpen}
        onClose={handleOnClose}
      />
      <Button size="small" onClick={openModal}>
        {I18n.t('publisher.organization_settings.test_saml_settings.test_new_saml_connection')}
      </Button>
    </>
  )
}
